"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Setting2Filled = void 0;
/* eslint-disable max-len */
var react_1 = __importDefault(require("react"));
var icon_1 = require("../utils/icon");
exports.Setting2Filled = (0, icon_1.makeIcon)({
    Path: function (_a) {
        var colors = _a.colors;
        return react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("path", { d: "M8.62485 0.870074C8.2381 0.646783 7.7616 0.646783 7.37485 0.870074L2.13744 3.8939C1.75068 4.11719 1.51244 4.52985 1.51244 4.97643V11.0241C1.51244 11.4707 1.75068 11.8833 2.13744 12.1066L7.37485 15.1304C7.76161 15.3537 8.2381 15.3537 8.62485 15.1304L13.8623 12.1066C14.249 11.8833 14.4873 11.4707 14.4873 11.0241V4.97643C14.4873 4.52985 14.249 4.11719 13.8623 3.8939L8.62485 0.870074ZM8.00001 10.25C9.24265 10.25 10.25 9.24266 10.25 8.00002C10.25 6.75738 9.24265 5.75002 8.00001 5.75002C6.75737 5.75002 5.75001 6.75738 5.75001 8.00002C5.75001 9.24266 6.75737 10.25 8.00001 10.25Z", fill: colors[0], fillRule: "evenodd", clipRule: "evenodd" }));
    },
    name: 'setting_2_filled',
    defaultColors: ['#D9D9D9'],
    colorful: false,
    allPathData: ['M8.62485 0.870074C8.2381 0.646783 7.7616 0.646783 7.37485 0.870074L2.13744 3.8939C1.75068 4.11719 1.51244 4.52985 1.51244 4.97643V11.0241C1.51244 11.4707 1.75068 11.8833 2.13744 12.1066L7.37485 15.1304C7.76161 15.3537 8.2381 15.3537 8.62485 15.1304L13.8623 12.1066C14.249 11.8833 14.4873 11.4707 14.4873 11.0241V4.97643C14.4873 4.52985 14.249 4.11719 13.8623 3.8939L8.62485 0.870074ZM8.00001 10.25C9.24265 10.25 10.25 9.24266 10.25 8.00002C10.25 6.75738 9.24265 5.75002 8.00001 5.75002C6.75737 5.75002 5.75001 6.75738 5.75001 8.00002C5.75001 9.24266 6.75737 10.25 8.00001 10.25Z'],
    width: '16',
    height: '16',
    viewBox: '0 0 16 16',
});
